// ng2 polyfills
import 'reflect-metadata';
import 'core-js/stable/array';
import 'core-js/stable/object';
import 'core-js/stable/string';
import 'core-js/stable/set';
import 'core-js/stable/map';
import 'core-js/stable/promise';
import 'core-js/stable/symbol';
import 'core-js/stable/weak-map';
import 'core-js/stable/weak-set';
import 'core-js/stable/reflect';
